import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import DrawerCustom from '../../components/DrawerCustom'
import { Grid, ListItem, InputBase, List, ListItemText } from '@material-ui/core';
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker'
import { LeftIcon,FavoriteActiveIcon, FavoriteIcon, GiftIcon } from '../../components/icons';
import Container from '../../components/Container';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import Divider from '../../components/Divider';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getAppCfg } from '../../utils/common';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';

const containerStyle = {
    width: '100%',
    height: '100%'
};
const heightCover = 200
const styles = theme => ({
    itemContainer: {
        padding: theme.spacing(2),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
        
    },
    itemContent: {
        borderRadius: theme.shape.borderRadius2x,
        backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        height: heightCover,
    },
    name: {
        width: '100%',
        padding: theme.spacing(2),
         position: 'absolute',
         //top: heightCover - theme.spacing(12),
         bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.1)',
    },
    cover: {
        width: '100%',
        height: heightCover,
        objectFit: 'contain',
        borderRadius: theme.shape.borderRadius2x,
    },
})
function OrderCatalogues(props) {
    const { open, onClose, classes, t, catalogActive, onSelectCatalog } = props;
    //console.log('catalogActive====', catalogActive)
    return (
        <Container showLoading={props.showLoading}>
            <DrawerCustom
                enableBack
                title={t('order_catalogues')}
                open={open}
                onClose={onClose}>
                <Grid xs={12} item>
                    {catalogActive.map((item, index) =>
                    <CatalogItem classes={classes} t={t} catalog={item} key={index} onSelectCatalog={onSelectCatalog}/>)}    
                </Grid>    
            </DrawerCustom>
        </Container>
    );
}
function CatalogItem(props){
    const { classes, t, catalog, onSelectCatalog } = props;
    var image = dataUtil.getImageByUsageTypePortal(catalog.creatives, usage_type.catalog)
    //console.log('catalog img=', image)
    return(
        <Grid xs={12} item className={classes.itemContainer}>
            <Grid xs={12} item className={classes.itemContent} onClick={()=>onSelectCatalog(catalog)}>
                <CatalogItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(catalog.creatives, usage_type.catalog)} />
                <Grid item className={classes.name}>
                    
                    <CustomTypo variant='h5' color='primary'>{catalog.name ? catalog.name : ""}</CustomTypo>
                </Grid>
            </Grid>
        </Grid>

    )
}

function CatalogItemImage(props) {
    const { classes, image } = props;
    if (image) {
        return <img src={image.url} className={classes.cover} />
    } else {
        return (
            <Grid xs={12} item className={classes.cover} alignItems='center' justify='center' container>
                <GiftIcon/>
            </Grid>
        )
    }
}
export default withStyles(styles)(withTranslation()(OrderCatalogues));